// actionType.js

export const UPLOAD_NOC = "UPLOAD_NOC";
export const UPLOAD_NOC_SUCCESS = "UPLOAD_NOC_SUCCESS";
export const UPLOAD_NOC_ERROR = "UPLOAD_NOC_ERROR";

export const DOWNLOAD_NOC_DOCUMENT = "DOWNLOAD_NOC_DOCUMENT";
export const DOWNLOAD_NOC_DOCUMENT_SUCCESS = "DOWNLOAD_NOC_DOCUMENT_SUCCESS";
export const DOWNLOAD_NOC_DOCUMENT_ERROR = "DOWNLOAD_NOC_DOCUMENT_ERROR";

export const FILTER_NOC_DOCUMENT = "FILTER_NOC_DOCUMENT";
export const FILTER_NOC_DOCUMENT_SUCCESS = "FILTER_NOC_DOCUMENT_SUCCESS";
export const FILTER_NOC_DOCUMENT_ERROR = "FILTER_NOC_DOCUMENT_ERROR";

export const GET_NOC_LIST = "GET_NOC_LIST";
export const GET_NOC_LIST_SUCCESS = "GET_NOC_LIST_SUCCESS";

export const DELETE_NOC_LIST = "DELETE_NOC_LIST";
export const DELETE_NOC_LIST_SUCCESS = "DELETE_NOC_LIST_SUCCESS";

export const NOC_API_ERROR_ACTION = "NOC_API_ERROR_ACTION";







